import React, { memo } from 'react';

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  source?: 'aws';
}

export const Image: React.FC<ImageProps> = memo(({ source, src, ...props }) => {
  const imageURL =
    source === 'aws'
      ? `${process.env.NEXT_PUBLIC_S3_BUCKET_URL}/images/${src}`
      : src;

  return <img src={imageURL} {...props} data-testid="Image" />;
});

Image.displayName = 'Image';
